<template>
  <div class="mt-8">
    <v-row>
      <!-- <v-col cols="12" class="d-flex">
        <div @click="tab = 0">
          <v-sheet
            :class="[
              'py-2 px-3 mr-2 cursor-pointer',
              tab == 0 ? 'white--text' : 'secondary--text',
            ]"
            :color="tab == 0 ? 'secondary' : 'bluishGrey'"
            key="tabRegsitrants"
            rounded="lg"
          >
            Registrants
          </v-sheet>
        </div>

        <div @click="tab = 1">
          <v-sheet
            :class="[
              'py-2 px-3 cursor-pointer',
              tab == 1 ? 'white--text' : 'secondary--text',
            ]"
            :color="tab == 1 ? 'secondary' : 'bluishGrey'"
            key="tabAskOfferOrNote"
            rounded="lg"
          >
            AskOffer/Note
          </v-sheet>
        </div>
      </v-col> -->
      <v-col cols="12">
        <v-tabs-items v-model="tab">
          <!--Start: Registrants Tab-->
          <v-tab-item>
            <v-row dense>
              <v-col cols="12" class="d-flex justify-space-between">
                <div>
                  <v-icon>mdi-account</v-icon>
                  <span class="text-subtitle">{{ noOfRegistrants }}</span>
                </div>
                <div>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    outlined
                    single-line
                    hide-details
                    rounded
                    dense
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-data-table
                  :headers="headers"
                  :search="search"
                  :items="linkRegistrants"
                  disable-pagination
                  hide-default-footer
                  class="mt-0"
                >
                  <template slot="no-data">
                    <div>You don't have any registrants yet</div>
                  </template>
                  <template v-slot:item.firstName="{ item }">
                    <v-list-item>
                      <UserAvatar
                        :key="item.businessCardId"
                        :usersInitials="
                          item.initials
                        "
                        :displayImageUrl="item.displayImageUrl"
                      />

                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          {{
                            item.firstName + " " + item.lastName
                          }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          item.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:item.jobTitle="{ item }">
                    {{ item.jobTitle != "" ? item.jobTitle : "-" }}
                  </template>
                  <template v-slot:item.company="{ item }">
                    {{
                      item.businessName != "" && item.businessName != undefined
                        ? item.businessName
                        : "-"
                    }}
                  </template>
                  <template v-slot:item.country="{ item }">
                    {{
                      item.country != "" && item.country != undefined
                        ? item.country
                        : "-"
                    }}
                  </template>
                  <template v-slot:item.visibility="{ item }">
                      {{
                    item.stayListedOnPage ? "Visible" : "Hidden"
                        }}
                  </template>
                  <template v-slot:item.subEvents="{ item }">
                    <div class="my-2">
                      <v-chip
                        label
                        small
                        color="#F6F7FC"
                        class="mr-2 mb-2"
                        v-for="(subEventName, index) in getAssociatedSubEvents(
                          item
                        )"
                        :key="`subEventNameChip${index}`"
                        >{{ subEventName }}</v-chip
                      >
                    </div>
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-menu
                      transition="slide-y-transition"
                      bottom
                      left
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon v-bind="attrs" v-on="on">
                          <v-icon>more_vert</v-icon>
                        </v-btn>
                      </template>
                      <v-list nav>
                        <v-list-item @click="showAttendeeDetails(item)">
                          <v-list-item-title>View Details</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="showBusinessCardOnDevice(item)">
                          <v-list-item-title>View profile</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="handleRemove(item)">
                          <v-list-item-title
                            >Remove from link</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </template>
                </v-data-table>
                <!--Start: Business Card on device dialog-->
                <v-dialog
                  v-model="businessCardOnDeviceDialog"
                  width="300"
                  content-class="device-corners"
                >
                  <BusinessCardOnDevice
                    :title="deviceTitle"
                    :subtitle="deviceSubtitle"
                    :line1="deviceLine1"
                    :line2="deviceLine2"
                    :line3="deviceLine3"
                  />
                </v-dialog>
                <!--End: Business Card on device dialog -->

                <!--Start: Confirmation dialog-->
                <ConfirmationDialog
                  :show="showConfirmationDialog"
                  title="Remove registrant?"
                  content="Are you sure, you want to remove this registrant?"
                  @click="removeRegistrant"
                  @closeDialog="showConfirmationDialog = false"
                  buttonText="Remove"
                />
                <!--End: Confirmation dialog-->
              </v-col>
            </v-row>
          </v-tab-item>
          <!--End: Registrants Tab-->

          <!--Start: Ask / Offer / Note tab--->
          <v-tab-item>
            <v-row>
              <v-col cols="12" class="d-flex">
                <div>
                  <v-icon> mdi-chat</v-icon>
                  <span class="text-subtitle ml-1">{{ noOfRegistrants }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="12">
                <v-data-table
                  :headers="askOfferNoteHeaders"
                  :items="linkRegistrants"
                  hide-default-footer
                  disable-pagination
                  class="mt-0 ask-offer-note-table"
                >
                  <template slot="header.askText">
                    <span class="primary--text rotate-text d-inline-block"
                      >Ask</span
                    >
                  </template>
                  <template slot="header.offerText">
                    <span class="primary--text rotate-text d-inline-block"
                      >Offer</span
                    >
                  </template>
                  <template slot="header.noteText">
                    <span class="primary--text rotate-text d-inline-block"
                      >Note</span
                    >
                  </template>
                  <template slot="no-data">
                    <div>You don't have any registrants yet</div>
                  </template>
                  <template v-slot:item.name="{ item }">
                    <v-list-item>
                      <UserAvatar
                        :key="item.businessCardId"
                        :usersInitials="
                          item.initials
                        "
                        :displayImageUrl="item.displayImageUrl"
                      />

                      <v-list-item-content>
                        <v-list-item-title class="font-weight-medium">
                          {{
                            item.firstName + " " + item.lastName
                          }}</v-list-item-title
                        >
                        <v-list-item-subtitle>{{
                          item.email
                        }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                  <template v-slot:item.askText="{ item }">
                    <div class="pt-2 whitespace-pre-line">
                      {{ item.askText != "" ? item.askText : "-" }}
                    </div>
                  </template>
                  <template v-slot:item.offerText="{ item }">
                    <div class="pt-2 whitespace- pre-line">
                      {{ item.offerText != "" ? item.offerText : "-" }}
                    </div>
                  </template>
                  <template v-slot:item.noteText="{ item }">
                    <div class="pt-2 whitespace-pre-line">
                      {{ item.noteText != "" ? item.noteText : "-" }}
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <!--End: Ask / Offer / Note tab--->
        </v-tabs-items>
      </v-col>
    </v-row>
  </div>
</template>

<script>

import UserAvatar from "@/components/UserAvatar";
import { mapActions, mapGetters } from "vuex";
import BusinessCardOnDevice from "@/components/BusinessCardOnDevice";
import ConfirmationDialog from "@/components/ConfirmationDialog";

import { getAuth } from "firebase/auth";

import Utility from "@/shared/utility";
import {deleteEventAttendeesDoc, getBusinessCardsDoc, queryEventAttendeesCollection} from "@/shared/firebase_utils";
import {onSnapshot, where} from "firebase/firestore";

export default {
  created() {
    this.usersEmail = getAuth().currentUser.email;
    this.getUsersFullName = Utility.getUsersFullName;
    this.attendees = this.currentEvent.attendees;
    onSnapshot(queryEventAttendeesCollection(where("eventId", "==", this.currentEvent.id)), (snapshot) => {
      snapshot.docs.forEach((doc) => {
        const indexOfAttendee = this.attendees.findIndex((attendee) => attendee.uid == doc.data().uid);
        if (indexOfAttendee != -1) {
          this.attendees[indexOfAttendee] = doc.data();
        } else {
          this.attendees.push(doc.data());
        }
      });
    });
    this.initializeLinkRegistrants();
    console.log("this.linkRegistrants: ", this.linkRegistrants);
  },
  components: {
    UserAvatar,
    BusinessCardOnDevice,
    ConfirmationDialog,
  },
  computed: {
    ...mapGetters(["currentEvent", "linkedSubEvents"]),
    noOfRegistrants() {
      if (this.linkRegistrants.length != 1) {
        let suffix = this.tab == 0 ? "registrants" : "AskOffer/Notes";
        return this.linkRegistrants.length + " " + suffix;
      } else {
        let suffix = this.tab == 0 ? "registrant" : "AskOffer/Note";
        return this.linkRegistrants.length + " " + suffix;
      }
    },
  },
  watch: {
    "currentEvent.attendees": function (attendees) {
      attendees.forEach(attendee => {
        const indexOfAttendee = this.attendees.indexOf(attendee);
        if (indexOfAttendee != -1) {
          this.attendees[indexOfAttendee] = attendee;
        } else {
          this.attendees.push(attendee);
        }
      });
    },
    "attendees": function (attendees) {
      console.log("Length of attendees", attendees.length);
      //Add attendee to linkRegistrants
      attendees.forEach((attendee) => {
        if (attendee.businessCardId != "") {
          let isBusinessCardRetrieved = false;

          for (let i = 0; i < this.linkRegistrants.length; i++) {
            if (this.linkRegistrants[i].id == attendee.businessCardId) {
              isBusinessCardRetrieved = true;
              break;
            }
          }

          if (!isBusinessCardRetrieved) {
            getBusinessCardsDoc(attendee.businessCardId)
              .then((doc) => {
                try {
                  let docData = {};
                  if (doc.exists()) {
                    docData = doc.data();
                  }
                  const firstName = docData.firstName || attendee.firstName || '';
                  const lastName = docData.lastName || attendee.lastName || '';
                  const initials = (firstName[0] || '') + ' ' + (lastName[0] || '');
                  const newRegistrant = {
                    id: doc.id,
                    ...attendee,
                    initials: initials,
                    invitedEmail: attendee.email,
                    attendeeUid: attendee.uid,
                    ...docData
                  };
                  const indexOfRegistrant = this.linkRegistrants.findIndex((registrant) => {
                    return registrant.id == newRegistrant.id
                  });
                  if (indexOfRegistrant != -1) {
                    this.linkRegistrants[indexOfRegistrant] = newRegistrant;
                  } else {
                    this.linkRegistrants.push(newRegistrant);
                  }
                }catch (e) {
                  console.error("Failed here", doc.exists());
                }
              });
          }
        }

      });
      //Remove attendee from linkRegistrants
      this.linkRegistrants.forEach((registrant, index) => {
        let isRegistrantRemoved = true;

        for (let i = 0; i < attendees.length; i++) {
          if (registrant.id == attendees[i].businessCardId) {
            isRegistrantRemoved = false;
            break;
          }
        }

        if (isRegistrantRemoved) this.linkRegistrants.splice(index, 1);
      });
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "firstName",
          align: "start",
        },
        { text: "Job Title", value: "jobTitle", align: "start" },
        { text: "Company", value: "company", align: "start" },
        { text: "Country", value: "country", align: "start" },
        { text: "Visibility", value: "visibility", align: "start" },
        { text: "Sub-events", value: "subEvents", align: "start" },
        { text: "Actions", value: "actions", align: "start" },
      ],
      search:'',
      deviceTitle: "",
      linkRegistrants: [],
      attendees: [],
      getUsersFullName: "",
      businessCardOnDeviceDialog: false,
      deviceSubtitle: "",
      deviceLine1: "",
      deviceLine2: "",
      deviceLine3: "",
      registrantToBeRemoved: null,
      showConfirmationDialog: false,
      tab: 0,
      askOfferNoteHeaders: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        { text: "Ask", value: "askText", align: "start", width: "25%" },
        { text: "Offer", value: "offerText", align: "start", width: "25%" },
        { text: "Note", value: "noteText", align: "start", width: "25%" },
      ],
    };
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    showBusinessCardOnDevice(businessCard) {
      window.open("https://app.pappyon.com/businessCard/" + businessCard.id);
    },
    async showAttendeeDetails(attendee) {
      let id;
      if (attendee.uid) {
        id = attendee.uid;
      } else {
        id = attendee.attendeeId;
      }
      await this.$router.push({
        name: "editAttendeeDetails",
        params: {
          attendeeId: id,
          eventId: this.currentEvent.id,
        },

      });
    },
    handleRemove(registrant) {
      console.log("remove registrant", registrant);
      this.registrantToBeRemoved = registrant;
      this.showConfirmationDialog = true;
    },

    removeRegistrant() {
      if (this.registrantToBeRemoved) {
        const indexOfRegistrant = this.currentEvent.attendees.findIndex((attendee) => {
          return attendee.id == this.registrantToBeRemoved.id;
        });
        if (indexOfRegistrant > -1) {
          this.currentEvent.attendees.splice(indexOfRegistrant, 1);
        } else {
          const uid = this.registrantToBeRemoved.uid;
          const eventId = this.currentEvent.id;
          const docRef = eventId + '-' + uid;
          deleteEventAttendeesDoc(docRef);
        }
      }
      this.currentEvent.save();
      this.showSnackbar({ show: true, text: "Removed successfully!" });
      this.showConfirmationDialog = false;
    },

    initializeLinkRegistrants(attendees) {
      attendees.forEach((attendee) => {
        if (attendee.businessCardId != "") {
          let isBusinessCardRetrieved = false;

          for (let i = 0; i < this.linkRegistrants.length; i++) {
            if (this.linkRegistrants[i].id == attendee.businessCardId) {
              isBusinessCardRetrieved = true;
              break;
            }
          }

          if (!isBusinessCardRetrieved) {
            getBusinessCardsDoc(attendee.businessCardId)
              .then((doc) => {
                if (doc.exists) {

                  const firstName = doc.data().firstName || attendee.firstName || '';
                  const lastName = doc.data().lastName || attendee.lastName || '';
                  const initials = (firstName[0] || '') + ' ' + (lastName[0] || '');
                  const registrant = {
                    id: doc.id,
                    ...attendee,
                    initials: initials,
                    invitedEmail: attendee.email,
                    attendeeUid: attendee.uid,
                    ...doc.data(),
                  };
                  console.log("registrant", registrant);
                  this.linkRegistrants.push(registrant);
                }
              });
          }
        }
      });

      //Remove attendee from linkRegistrants
      this.linkRegistrants.forEach((registrant, index) => {
        let isRegistrantRemoved = true;

        for (let i = 0; i < attendees.length; i++) {
          if (registrant.id == attendees[i].businessCardId) {
            isRegistrantRemoved = false;
            break;
          }
        }

        if (isRegistrantRemoved) this.linkRegistrants.splice(index, 1);
      });
    },
    getAssociatedSubEvents(attendee) {
      let associatedSubEvents = [];
      this.linkedSubEvents.forEach((subEvent) => {
        let isAttendeeOfSubEvent = subEvent.attendees.some(
          (item) => item.uid == attendee.uid
        );
        if (
          isAttendeeOfSubEvent &&
          !associatedSubEvents.includes(subEvent.name)
        )
          associatedSubEvents.push(subEvent.name);
      });
      return associatedSubEvents;
    },
  },
};
</script>

<style>
.rotate-text {
  transform: rotate(-11.09deg) !important;
}

.whitespace-pre-line {
  white-space: pre-line !important;
  display: flex;
  align-items: flex-end;
}

.ask-offer-note-table tr td {
  vertical-align: top !important;
  padding: 0.5rem 0.5rem !important;
  cursor: pointer;
}
</style>
